import { Grid, Typography } from '@mui/material';
import { FormikHelpers } from 'formik';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Layout from '../../../core/ui/layout/Layout';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import { parseValidationErrors } from '../../../core/utils/validation';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import Loader from '../../../core/ui/utility/Loader';
import { BrandPartnershipEdit, BrandPartnership } from '../brandPartnership';
import EditBrandPartnershipForm from '../components/EditBrandPartnershipForm';
import ReturnButton from '../../../core/ui/utility/ReturnButton';
import { parseFormQuery } from '../../../core/utils/utility';

const EditBrandPartnershipContainer = () => {
  const { id } = useParams();
  const { callApi, loading: submitting } = useSendApiData();
  const { fetchData, loading } = useFetchApiData();
  const [brandPartnership, setBrandPartnership] =
    useState<BrandPartnership | null>(null);

  const fetchBrandPartnership = () =>
    fetchData(`auth-bana29/brands/${id}`, {
      onSuccess: (data: BrandPartnership) => {
        setBrandPartnership(data);
      },
    });

  useEffect(() => {
    fetchBrandPartnership();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (
    values: BrandPartnershipEdit,
    { setFieldError }: FormikHelpers<BrandPartnershipEdit>
  ) => {
    const formData: any = parseFormQuery(values, []);

    await callApi({
      endpoint: `auth-bana29/brands/${id}`,
      method: 'patch',
      data: formData,
      headers: {
        'Content-Type': 'application/json',
      },
      onValidationError: (err) => parseValidationErrors(err, setFieldError),
      onError: toastError,
      onSuccess: async (_) => {
        await fetchBrandPartnership();
        toastMessage('BrandPartnership Edited');
      },
    });
  };

  return (
    <Layout renderLeftToolbar={() => <ReturnButton to="/brand-partnerships" />}>
      <Loader loading={loading || !brandPartnership}>
        <Grid sx={{ p: 2 }}>
          <Grid container sx={{ mb: 1, px: 1 }}>
            <Typography variant="h5">View Brand Partnership</Typography>
          </Grid>
          <EditBrandPartnershipForm
            brandPartnership={brandPartnership!}
            onSubmit={handleSubmit}
            submitting={submitting}
          />
        </Grid>
      </Loader>
    </Layout>
  );
};

export default EditBrandPartnershipContainer;
